import { Button, Checkbox, Divider, Flex, Typography } from "antd";
import { useContext, useState } from "react";
import LoaderContext from "../../../../Context/LoaderContext/Index";
import {
  InterviewSession,
  QuestionCandidate,
} from "../../../../Interface/Index";
import "./instruction.scss";

const instructions = [
  {
    instruction:
      "This questionnaire is designed to help us understand you better and assess your fit for this job role. Please provide detailed answers.",
  },
  {
    instruction:
      "Following activities are strictly prohibited and will result in termination of this interview:",
    subInstructions: [
      "On starting this questionnaire, the screen will enter full screen mode. Exiting from this full screen mode is strictly prohibited.",
      "Copy and paste actions are disabled.",
      "Complete the questionnaire in a single session.",
    ],
  },
  {
    instruction:
      "Answer with your own knowledge and refrain from using any AI assistants, as this defeats the purpose of the evaluation.",
  },
  {
    instruction:
      "Your responses will be evaluated by an AI hiring assistant QualifyMe and the results will be available immediately.",
  },
  {
    instruction:
      "During the interview round, your webcam will be activated and your face will be recorded for monitoring and evaluation purposes.",
  },
];

interface InstructionsProps {
  handleStart: () => void;
  session: InterviewSession | null;
  questions: QuestionCandidate[];
}

const Instructions: React.FC<InstructionsProps> = ({
  handleStart,
  questions,
  session,
}) => {
  const { isLoading } = useContext(LoaderContext);
  const [accepted, setAccepted] = useState(false);

  const handleAcceptClick = (e: any) => {
    setAccepted(e.target.checked);
  };

  let estimatedTime = session ? session?.noOfQuestionsGenerated * 3 : 0;

  return (
    <Flex vertical className="instruction_container">
      <Typography.Title level={3} style={{ textAlign: "center" }}>
        Important Instructions
      </Typography.Title>
      <Typography.Title
        level={5}
        style={{ textDecoration: "underline", textAlign: "center" }}
      >
        Estimated time: {estimatedTime} minutes
      </Typography.Title>
      <ol style={{ lineHeight: "2", paddingLeft: "20px", width: "100%" }}>
        {instructions.map((item, index) => (
          <li key={index} className="instruction_list">
            {item.instruction.includes("QualifyMe") ? (
              <>
                Your responses will be evaluated by an AI hiring assistant{" "}
                <b>QualifyMe</b> and the results will be available immediately.
              </>
            ) : (
              item.instruction
            )}
            {item.subInstructions && (
              <ul
                style={{
                  marginTop: "8px",
                  paddingLeft: "20px",
                  lineHeight: "1.8",
                }}
              >
                {item.subInstructions.map((sub, subIndex) => (
                  <li key={subIndex}>{sub}</li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ol>
      <Divider />
      <div style={{ textAlign: "center" }}>
        <Checkbox onChange={handleAcceptClick}>
          I read the instructions and understand the termination rules
        </Checkbox>
      </div>
      <div className="start_button_container">
        <Button
          type="primary"
          onClick={handleStart}
          loading={isLoading}
          disabled={!accepted || session?.status === "unqualified"}
          style={{ paddingInline: "100px" }}
        >
          Start
        </Button>
      </div>
    </Flex>
  );
};

export default Instructions;
